module.exports = __webpack_public_path__ + "img/furbolg_abode_small.3087f52a.png";